import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import ProductLabel from '../product/ProductLabel'
import Input from '../Input'
import Textarea from '../Textarea'
import Button from '../Button'

const OrderReturnSubmitModal = (props) => {

    const { isOpen, closeModal, cut, setReturnAmount, returnAmount, setReturnPrice, returnPrice, onClick, description, setDescription, date, setDate, errors, setErrors, pendingApiCall } = props


    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>
                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 mb-3"
                                >
                                    İade
                                </Dialog.Title>
                                <div className='p-3 shadow-md border rounded-md mb-3'>
                                    <div className='flex gap-x-2'>Barkod No : {cut?.roll?.upc}</div>
                                    <div className='flex gap-x-2'>Ürün : <ProductLabel state={cut?.roll?.product} /> </div>
                                    <div className='flex gap-x-2'>Kazan No : {cut?.roll?.boilerCode} </div>
                                    <div className='flex gap-x-2'>Metre : {cut.quantity} m</div>
                                    <div className='flex gap-x-2'>Birim Fiyat : {cut?.orderDetail?.unitPrice}</div>
                                    <div className='flex gap-x-2'>Birim Maliyet : {cut?.roll?.unitCost} USD/m</div>
                                </div>
                                <div>
                                    <Input
                                        label='İade Miktarı'
                                        placeholder='İade miktarı girin (m)'
                                        type='number'
                                        onChange={e => { setReturnAmount(e.target.value); setErrors(prev => ({ ...prev, quantity: undefined })) }}
                                        value={returnAmount}
                                        error={errors.quantity}
                                    />
                                    <Input
                                        label='İade Birim Fiyat'
                                        placeholder='İade birim fiyat girin'
                                        type='number'
                                        value={returnPrice}
                                        onChange={e => setReturnPrice(e.target.value)}
                                    />
                                    <Input
                                        label='İade Tarihi'
                                        type='date'
                                        value={date}
                                        onChange={e => { setDate(e.target.value); setErrors(prev => ({ ...prev, returnmentDate: undefined })) }}
                                        error={errors.returnmentDate}
                                    />
                                    <Textarea
                                        label='Açıklama'
                                        placeholder='Açıklama girin'
                                        type='text'
                                        value={description}
                                        onChange={e => setDescription(e.target.value)}
                                    />
                                </div>
                                <Button
                                    text='Kaydet'
                                    variant='green'
                                    pendingApiCall={pendingApiCall}
                                    onClick={onClick}
                                />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default OrderReturnSubmitModal